export default __webpack_public_path__ + "static/media/supermidsize.ef62656d.png";